import React, { Component } from "react";
import "./MyNavbar.css";
import { BASE_URL } from "../../constants/index";
import { getCookie } from "../../helpers/cookieHelper";
import { logout } from "../../helpers";

export default class MyNavbar extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      permissions: [],
      client: false
    };
  }
  myHandler() {
    const nodeList = document.querySelectorAll("span.dropdown-toggle");
    nodeList.forEach((elem) => {
      let subMenu = elem.nextElementSibling;
      subMenu.classList.remove("show");
    });
  }

  componentWillMount() {
    var data = getCookie("permission");
    if (data == null) {
      window.location = BASE_URL;
      return;
    }
  }

  componentDidMount() {
    document.body.addEventListener("click", this.myHandler);
    var data = getCookie("permission");

    if (JSON.parse(data).includes("client-registration") && JSON.parse(data).includes("reset-password") && JSON.parse(data).includes("technical-access") && JSON.parse(data).includes("client-payment") && JSON.parse(data).includes("active-maintainance-mode") && JSON.parse(data).includes("publish-notice")) {
      this.setState({
        client: true
      })
    }

    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        const nodeList = document.querySelectorAll("span.dropdown-toggle");
        nodeList.forEach((elem) => {
          //console.log(elem);
          elem.addEventListener("click", (e) => {
            e.stopPropagation();

            let subMenu = elem.nextElementSibling;
            subMenu.classList.toggle("show");
            const allParentList = document.querySelectorAll(".dropdown.parent");
            allParentList.forEach((a) => {
              if (subMenu.closest(".dropdown.parent") !== a) {
                a.querySelectorAll("ul").forEach((s) => {
                  if (s.classList.contains("show")) {
                    s.classList.remove("show");
                  }
                });
              }
            });
            if (!subMenu.classList.contains("show")) {
              let menusToClose = subMenu.querySelectorAll("ul.dropdown-menu");
              menusToClose.forEach((menuToClose) => {
                menuToClose.classList.remove("show");
              });
            }
          });
        });
      }
    );
  }
  //function to check all permission,if one is present it will return true
  checkPermission = (data) => {
    let tempAccess = false;
    data.forEach((access) => {
      if (this.state.permissions.includes(access)) {
        tempAccess = true;
      }
    })
    return tempAccess;

  }

  toggle() {
    var isOpen = this.state.isOpen;
    this.setState({
      isOpen: !isOpen,
    });
  }
  render() {
    var permissions = this.state.permissions;
    return (
      <div style={{ marginBottom: 10 }}>
        <nav
          className='navbar navbar-expand-md navbar-dark bg-purple'
          style={{ background: "#2d3e50" }}
        >
          <a className='navbar-brand' href={BASE_URL + "dashboard"}>
            Dashboard
          </a>
          <button
            className='navbar-toggler'
            type='button'
            data-toggle='collapse'
            data-target='#navbarNavDropdown'
            aria-controls='navbarNavDropdown'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarNavDropdown'>
            <ul className='navbar-nav'>
              {permissions.includes("price-plan") ? (
                <li className='nav-item parent'>
                  <a className='nav-link' href={BASE_URL + "priceplan"}>
                    Price Plan
                  </a>
                </li>
              ) : (
                ""
              )}

              {this.state.client === true
                ? (
                  <li className='nav-item dropdown parent'>
                    <span
                      className='nav-link dropdown-toggle'
                      id='navbarDropdownMenuLink'
                      data-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                    >
                      Client
                    </span>
                    <ul
                      className='dropdown-menu'
                      aria-labelledby='navbarDropdownMenuLink'
                    >
                      {permissions.includes("client-registration") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "client-registration"}
                          >
                            Client Registration
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("client-registration") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "client-registration-for-other-software"}
                          >
                            Client Registration For Other Software
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {this.checkPermission(["client-registration","client-registration-for-other-software", "reset-password", "technical-access"]) ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "client-list"}
                          >
                            Client List
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("client-payment") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "client-payment"}
                          >
                            Client Payment
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("active-maintainance-mode") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "activate-maintaince-mode"}
                          >
                            Activate Maintainance Mode
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("publish-notice") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "publish-notice"}
                          >
                            Publish Notice
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                ) : (
                  ""
                )}


              <li className='nav-item dropdown parent'>
                <span
                  className='nav-link dropdown-toggle'
                  id='navbarDropdownMenuLink'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                >
                  System
                </span>
                <ul
                  className='dropdown-menu'
                  aria-labelledby='navbarDropdownMenuLink'
                >
                  {this.checkPermission([
                    "create-user-group",
                    "technical-access",
                    "user-registration",
                    "reset-password"
                  ]
                  ) ? (
                    <>
                      {
                        permissions.includes("create-user-group-create") ? (
                          <li>
                            <a
                              className='dropdown-item'
                              href={BASE_URL + "create-user-group"}
                            >
                              Create User Group
                            </a>
                          </li>
                        ) : (
                          ""
                        )
                      }
                      {permissions.includes("create-user-group-view") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "view-user-group"}
                          >
                            View User Group
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("user-registration") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "marketing-agent"}
                          >
                            Marketing Agent
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("user-registration") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "user-registration"}
                          >
                            User Registration
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("reset-password") ? (
                        <li>
                          <a
                            className='dropdown-item '
                            href={BASE_URL + "change-password"}
                          >
                            Change Password
                          </a>
                        </li>
                      ) : ""}

                      {permissions.includes("technical-access") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "script-detail-page"}
                          >
                            Script Detail
                          </a>
                        </li>
                      ) : null}
                    </>
                  ) : (
                    ""
                  )}
                  {
                    permissions.includes("technical-access") ? (
                      <li>
                        <a
                          className='dropdown-item'
                          href={BASE_URL + "modules-detail-page"}
                        >
                          Modules Detail
                        </a>
                      </li>
                    ) : (
                      ""
                    )
                  }

                  <li>
                    <span
                      className='dropdown-item'
                      style={{ cursor: "pointer" }}
                      onClick={logout}
                    >
                      Logout
                    </span>
                  </li>
                </ul>
              </li>



              <li className='nav-item dropdown parent'>
                <span
                  className='nav-link dropdown-toggle'
                  id='navbarDropdownMenuLink'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                >
                  Project Management
                </span>

                {/* {console.log(permissions.includes("ticket"))} */}
                <ul
                  className='dropdown-menu'
                  aria-labelledby='navbarDropdownMenuLink'
                >

                  {this.checkPermission([
                    "ticket",

                    "timesheet"

                  ]

                  ) ? (
                    <>
                      {
                        permissions.includes("timesheet") ? (
                          <>
                            <li>
                              <a
                                className='dropdown-item'
                              // href={BASE_URL + "timesheet-system-page"}
                              >
                                Timesheet System
                              </a>
                              <ul style={{ listStyleType: "none" }}>
                                {permissions.includes('timesheet-create') ? (
                                  <li>
                                    <a
                                      className='dropdown-item'
                                      href={BASE_URL + "timesheet-system-page"}
                                    >
                                      My Timesheet
                                    </a>
                                  </li>
                                ) : ""}
                                {permissions.includes('hrm-view') && permissions.includes('project-view') ? (
                                  <li>
                                    <a
                                      className='dropdown-item'
                                      href={BASE_URL + "timesheet-system-approval-page"}
                                    >
                                      Timesheet Approval
                                    </a>
                                  </li>
                                ) : ""}
                                {permissions.includes('hrm-view') && permissions.includes('project-view') ? (
                                  <li>
                                    <a
                                      className='dropdown-item'
                                      href={BASE_URL + "timesheet-system-report-page"}
                                    >
                                      Timesheet Report
                                    </a>
                                  </li>
                                ) : ""}

                              </ul>
                            </li>

                          </>
                        ) : (
                          ""
                        )
                      }
                      {
                        permissions.includes("ticket-create") ? (
                          <li>
                            <a
                              className='dropdown-item'
                              href={BASE_URL + "ticketing-detail-page"}
                            >
                              Ticketing Detail
                            </a>
                          </li>
                        ) : (
                          ""
                        )
                      }
                      {permissions.includes("create-user-group-create") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "priority-detail-page"}
                          >
                            Priority Detail
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("create-user-group-create") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "project-detail-page"}
                          >
                            Project Detail
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("create-user-group-create") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "ticket-status-detail-page"}
                          >
                            Ticket Status Detail
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("create-user-group-create") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "ticket-type-detail-page"}
                          >
                            Ticket Type Detail
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {permissions.includes("create-user-group-create") ? (
                        <li>
                          <a
                            className='dropdown-item'
                            href={BASE_URL + "version-detail-page"}
                          >
                            Version Detail
                          </a>
                        </li>
                      ) : (
                        ""
                      )}


                    </>
                  ) : (
                    ""
                  )}

                </ul>
              </li>

              {this.checkPermission([
                "client-payment-report",
                "client-license-expiry-report",
                "client-ledger-report"]
              ) ? (
                <li className='nav-item dropdown parent'>
                  <span
                    className='nav-link dropdown-toggle'
                    id='navbarDropdownMenuLink'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                  >
                    Reports
                  </span>
                  <ul
                    className='dropdown-menu'
                    aria-labelledby='navbarDropdownMenuLink'
                  >
                    {permissions.includes("client-payment-report") ? (
                      <li>
                        <a
                          className='dropdown-item'
                          href={BASE_URL + "client-payment-report"}
                        >
                          Client Payment Report
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {permissions.includes("client-ledger-report") ? (
                      <li>
                        <a
                          className='dropdown-item'
                          href={BASE_URL + "client-ledger-report"}
                        >
                          Client Ledger Report
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}
